import React, { forwardRef } from 'react';
import { useService } from '@wix/services-manager-react';
import { EnvironmentDefinition } from '@wix/viewer-service-environment/definition';
import AnimatedIcon from './AnimatedIcon';
import type { AnimatedSvgRef, AnimatedIconBuilderProps } from './types';

const AnimatedIconWithReducedMotion = forwardRef<
  AnimatedSvgRef,
  AnimatedIconBuilderProps
>((props, ref) => {
  const environment = useService(EnvironmentDefinition);
  const reducedMotion = environment.reducedMotion;

  return <AnimatedIcon {...props} ref={ref} reducedMotion={reducedMotion} />;
});

export default AnimatedIconWithReducedMotion;
